<template>
  <tv-page title="TV标销-订单支付结果" :class="_.page">
    <template v-if="!loading">
      <div :class="_.result">
        <img src="./images/成功.png" />
        <p :class="_.hint">订单支付成功!</p>
        <div v-if="globalModel" :class="_.btn">
          <span
            v-if="globalModel.state.bizHomeUrl"
            v-focusable
            @click="handleClickReturn"
            >返回专区首页</span
          >
          <span
            v-if="globalModel.state.bizOrderUrl"
            ref="look"
            v-focusable
            @click="handleClickLook"
            >查看订单</span
          >
        </div>
      </div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import { dcb } from '@dcb/jssdk'
  import { globalModel } from '@/model'
  import { mapQuery, Track } from '@/utils'
  import { navigateBack, navigateTo } from '../../../../router'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        // 埋点页面名称
        name: 'TV标销-订单支付结果',
      })),
      mapQuery({
        // 订单编号
        orderNo: 'orderNo',
      }),
    ],

    data: () => ({
      // 页面加载状态
      loading: true,
      globalModel: '',
    }),

    mounted() {
      this.globalModel = globalModel
      console.log(globalModel)
      this.loading = false
      this.$nextTick(() => {
        if (globalModel.state.bizOrderUrl) {
          this.$tv.goTo(this.$refs.look)
        }
      })
    },

    methods: {
      handleClickReturn() {
        console.log(globalModel)
        if (globalModel.state.bizHomeUrl) {
          dcb.navigateTo({
            url: globalModel.state.bizHomeUrl,
          })
        } else {
          navigateBack(3)
        }
      },

      handleClickLook() {
        console.log(globalModel)
        if (globalModel.state.bizOrderUrl) {
          dcb.navigateTo({
            url: globalModel.state.bizOrderUrl,
          })
        } else {
          navigateTo('TvBookOrderIndex')
        }
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    background-color: #1f2733;
  }

  .result {
    padding: 250px 520px;
    text-align: center;

    img {
      width: 200px;
      height: 200px;
    }

    .hint {
      font-size: 62px;
      font-weight: bold;
      color: #ffffff;
      line-height: 90px;
      margin-top: 60px;
      margin-bottom: 80px;
    }

    .btn {
      font-size: 44px;
      color: #ffffff;
      line-height: 64px;
      display: flex;
      justify-content: space-between;

      span {
        display: block;
        width: 420px;
        height: 120px;
        line-height: 120px;
        border-radius: 60px;
        --border-radius: 80px;
        background: rgba(255, 255, 255, 0.1);
        color: #d6d8da;

        &[focused] {
          background: linear-gradient(312deg, #ff6d00 0%, #ffd31a 100%);
          color: #ffffff;
        }
      }
    }
  }
</style>
